import React from "react";
import { EnvironmentFilled, DeleteOutlined } from "@ant-design/icons";

export default function AddressCard(props: any) {
  const { item, onDelete } = props;

  return (
    <div className="group border border-neutral-200 rounded-xl p-4 bg-white hover:border-neutral-300 hover:shadow-sm transition-all">
      <div className="flex items-start gap-3">
        <div
          className="h-10 w-10 rounded-full bg-[#06509E]/10 text-[#06509E] flex items-center justify-center shrink-0"
          aria-hidden
        >
          <EnvironmentFilled />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-start justify-between gap-2">
            <h3 className="font-semibold text-neutral-900 truncate">
              {item.label}
            </h3>
            {onDelete && (
              <button
                type="button"
                onClick={() => onDelete(item)}
                aria-label={`Delete ${item.label} address`}
                className="shrink-0 h-8 w-8 rounded-lg flex items-center justify-center text-neutral-400 hover:text-red-600 hover:bg-red-50 transition-colors"
              >
                <DeleteOutlined />
              </button>
            )}
          </div>
          {item.landmark && (
            <p className="text-sm text-neutral-600 mt-0.5 truncate">
              {item.landmark}
            </p>
          )}
          {item.town && (
            <p className="text-sm text-neutral-500 truncate">{item.town}</p>
          )}
        </div>
      </div>
    </div>
  );
}
